// Workspace mit Starter Picker und Board-Canvas. Picker wird in S3.3 ersetzt;
// hier nur noch der Switch zwischen Picker und aktiver Board-Ansicht.

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { StarterPicker } from "../board-list/StarterPicker.js";
import { Canvas } from "../canvas/Canvas.js";
import "./Workspace.css";

export function Workspace(): JSX.Element {
  const { t } = useTranslation();
  const [boardId, setBoardId] = useState<string | null>(null);

  if (boardId) {
    return (
      <div className="workspace-shell">
        <div className="workspace-toolbar">
          <button type="button" className="workspace-back" onClick={() => setBoardId(null)}>
            ← {t("workspace.back")}
          </button>
          <code className="workspace-board-id">{boardId}</code>
        </div>
        <Canvas boardId={boardId} />
      </div>
    );
  }

  return <StarterPicker onOpenBoard={setBoardId} />;
}
